import UploadFile from "@mui/icons-material/UploadFile";
import { Button, ButtonProps } from "@mui/material";
import { useQueueManifestDocumentExtraction } from "hooks/useQueueManifestDocumentExtraction";
import { useState } from "react";

import { ManifestReviewDialog } from "./ManifestReviewDialog";
import { ManifestUploadDialog } from "./ManifestUploadDialog";

type AddManifestButtonProps = {
  tenantId: string;
  facilityId?: string;
  manifestTrackingNumber?: string;
  generatorId?: string;
  /** MUI Button size — defaults to "medium" */
  size?: ButtonProps["size"];
};
export function AddManifestButton({
  tenantId,
  facilityId,
  manifestTrackingNumber,
  generatorId,
  size,
}: AddManifestButtonProps) {
  const { canQueueManifestExtraction } = useQueueManifestDocumentExtraction();
  const [open, setOpen] = useState(false);
  const [reviewDocumentIds, setReviewDocumentIds] = useState<string[] | null>(null);

  if (!canQueueManifestExtraction) return null;

  return (
    <>
      <Button
        variant="contained"
        size={size}
        startIcon={<UploadFile />}
        onClick={() => setOpen(true)}
      >
        Add Manifest
      </Button>

      {open && (
        <ManifestUploadDialog
          open
          onClose={() => setOpen(false)}
          tenantId={tenantId}
          facilityId={facilityId}
          manifestTrackingNumber={manifestTrackingNumber}
          generatorId={generatorId}
          onExtractionReady={setReviewDocumentIds}
        />
      )}

      {reviewDocumentIds && (
        <ManifestReviewDialog
          onClose={() => setReviewDocumentIds(null)}
          documentIds={reviewDocumentIds}
        />
      )}
    </>
  );
}
